import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Kecamatan = () => {
    const columns = [
        {
            name: 'Kode Kecamatan',
            cell: row => row['kodeKecamatan']
        },
        {
            name: 'Nama',
            cell: row => row['uraianKecamatan']
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listKecamatan, setlistKecamatan] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistKecamatan = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listKecamatan(null, null, page, size)
            setlistKecamatan(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistKecamatan([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistKecamatan(0, 10)
    }, [getlistKecamatan])

    const handleChangePage = (page) => {
        getlistKecamatan(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listKecamatan(null, null, page - 1, size)
        setlistKecamatan(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Kecamatan</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listKecamatan}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default Kecamatan